export interface ContributorAcknowledgements {
  contributorsList: ContributorAcknowledgement[];
  code: string;
  message: string;
  success: boolean;
  resultCount: number;
  totalCount: number;
  nextKey: string;
}

export interface ContributorAcknowledgement {
  linuxFoundationId: string;
  githubId: string;
  name: string;
  timestamp: string;
  signatureVersion: string;
  photoUrl: string;
  signatureApproved: boolean;
  signatureId: string;
  signatureModified: string;
  signatureSigned: boolean;
  userDocusignDateSigned: string;
  userDocusignName: string;
}

export interface IndividualSignatureForCLAGroup {
  github_username: string;
  gitlab_username: string;
  lf_username: string;
  signatureApproved: boolean;
  signatureModified: string;
  signatureSigned: boolean;
  signature_id: string;
  signed_on: string;
  userDocusignDateSigned: string;
  userDocusignName: string;
  user_email: string;
  user_id: string;
  user_name: string;
}

export interface ListIndividualSignaturesForCLAGroupResponse {
  lastKeyScanned: string;
  list: IndividualSignatureForCLAGroup[];
  pageSize: number;
  resultCount: number;
}

export interface ListIndividualSignaturesForCLAGroupQueryParms {
  searchTerm?: string;
  sortOrder?: string;
  pageSize?: number;
  nextKey?: string;
  approved?: boolean;
  signed?: boolean;
}

export interface UpdateAutoCreateEclaFlagInput {
  companyID: string;
  claGroupID: string;
  autoCreateEcla: boolean;
}

export interface UpdateAutoCreateEclaFlagResponse {
  autoCreateECLA: boolean;
  claType: string;
  companyName: string;
  created: string;
  domainApprovalList: string[];
  emailApprovalList: string[];
  githubOrgApprovalList: string[];
  githubUsernameApprovalList: string[];
  gitlabOrgApprovalList: string[];
  gitlabUsernameApprovalList: string[];
  modified: string;
  projectID: string;
  signatoryName: string;
  signatureACL: SignatureACL[];
  signatureApproved: boolean;
  signatureCreated: string;
  signatureID: string;
  signatureMajorVersion: string;
  signatureMinorVersion: string;
  signatureModified: string;
  signatureReferenceID: string;
  signatureReferenceName: string;
  signatureReferenceNameLower: string;
  signatureReferenceType: string;
  signatureSigned: boolean;
  signatureType: string;
  signedOn: string;
  signingEntityName: string;
  userDocusignDateSigned: string;
  userDocusignName: string;
  userGHID: string;
  userGHUsername: string;
  userGitlabID: string;
  userGitlabUsername: string;
  userLFID: string;
  userName: string;
  version: string;
}

export interface SignatureACL {
  admin: boolean;
  companyID: string;
  dateCreated: string;
  dateModified: string;
  emails: string[];
  githubID: string;
  githubUsername: string;
  gitlabID: string;
  gitlabUsername: string;
  lfEmail: string;
  lfUsername: string;
  note: string;
  userCompanyID: string;
  userExternalID: string;
  userID: string;
  username: string;
  version: string;
}

export interface ListClaGroupCorporateContributorsResponse {
  list: ClaGroupCorporateContributorsList[];
  nextKey: string;
  resultCount: number;
  totalCount: number;
}

export interface ClaGroupCorporateContributorsList {
  email: string;
  github_id: string;
  linux_foundation_id: string;
  name: string;
  signatureApproved: boolean;
  signatureID: string;
  signatureModified: string;
  signatureSigned: boolean;
  signature_version: string;
  timestamp: string;
  userDocusignDateSigned: string;
  userDocusignName: string;
}

export interface ListClaGroupCorporateContributorsQueryParms {
  searchTerm?: string;
  companyID?: string;
  pageSize?: number;
  nextKey?: string;
}
